import { useNavigate } from "react-router-dom";
import { Box, ButtonStyledTb, FormButtonStyled, HeadingStyled, LabelStyled } from "../../../components/styled/Elements";
import { ProfileEditContainer } from "./styled";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Col, Form, Row } from "react-bootstrap";
import DateSelector from "../../../components/common/dateSelector/DateSelector";
import TimeSlotSelector from "../../../components/common/timeSlotSelector/TimeSlotSelector";
import UsersApi from "../../../services/api/usersApi";

const SetAvailability = () => {
  const { t } = useTranslation();
  const {
    watch,
    setValue,
    handleSubmit,
  } = useForm({
    defaultValues: {
      date: [],
      time: [],
    },
  });
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    const loadAvailability = async () => {
      try {
        setInitialLoading(true);
        const { data, code } = await UsersApi.getAvailability();
        if (code === 200 && data) {
          setValue("date", data.dates ?? []);
          setValue("time", data.time_slots ?? []);
        }
      } catch (error) {
        toast.error(t("something_went_wrong"));
      } finally {
        setInitialLoading(false);
      }
    };
    loadAvailability();
  }, [setValue, t]);

  const onSubmit = async (formObj) => {
    const dates = formObj.date ?? [];
    const timeSlots = formObj.time ?? [];
    if (dates.length === 0 && timeSlots.length === 0) {
      toast.error(t("settings_select_date_or_slot"));
      return;
    }
    try {
      setLoading(true);
      const { code, message, error } = await UsersApi.saveAvailability({
        dates,
        time_slots: timeSlots,
      });
      if (code === 200) {
        toast.success(message || t("settings_availability_saved"));
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
      if (code === 422) {
        toast.error(error || message);
      }
    } catch (error) {
      toast.error(t("something_went_wrong"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <ProfileEditContainer>
      <HeadingStyled size="24px" className="editProfileHeading">
        {t("setAvailability")}
      </HeadingStyled>
      {initialLoading ? (
        <Box className="py-5 text-center">{t("loading")}</Box>
      ) : (
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Box className="profileFormContainerInner">
            <Row className="mt-3">
              <Col md={12}>
                <div className="my-4">
                  <LabelStyled color="var(--text)" className="mb-2">{t("select_day")}</LabelStyled>
                  <DateSelector
                    selectedDates={watch("date")}
                    setSelectedDates={(value) => setValue("date", value)}
                  />
                </div>
              </Col>
              <Col md={12} className="mt-3">
                <div>
                  <LabelStyled color="var(--text)" className="mb-2">{t("time_slot")}</LabelStyled>
                  <TimeSlotSelector
                    selectedSlots={watch("time")}
                    setSelectedSlots={(value) => setValue("time", value)}
                  />
                </div>
              </Col>
            </Row>
            <Box className="formBtns">
              <ButtonStyledTb
                className="nextStepBtn"
                type="button"
                bg="var(--white)"
                border="var(--border)"
                color="var(--darkGrey)"
                onClick={() => navigate("/my-profile")}
              >
                {t("Cancel")}
              </ButtonStyledTb>
              <FormButtonStyled
                type="submit"
                label={t("Update")}
                disabled={loading}
                isLoading={loading}
                bg="var(--themeColorSecondary)"
              />
            </Box>
          </Box>
        </Form>
      )}
    </ProfileEditContainer>
  );
};

export default SetAvailability;
